var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wechat-evaluate-index" },
    [
      _c("div", { staticClass: "search-area" }, [
        _c("div", { staticClass: "search-content" }, [
          _c(
            "div",
            { staticClass: "filter-section" },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.searchForm },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        on: { change: _vm.handleDateRangeChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "radio-area" },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small" },
              on: { change: _vm.handleTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: "all" } }, [
                _vm._v("全部"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: "negative" } }, [
                _vm._v("差评"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-area" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticClass: "evaluate-table",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "评价编号", align: "center", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "comment-id-danger": _vm.isBadCommentUnresolved(
                                scope.row
                              ),
                            },
                          },
                          [_vm._v(_vm._s(scope.row.commentid || "-"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单信息", align: "center", width: "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "order-info" }, [
                          _c("div", { staticClass: "order-sn" }, [
                            _vm._v(_vm._s(scope.row.orderSn || "-")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "store-name" }, [
                            _vm._v(_vm._s(scope.row.storeName || "-")),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "用户", align: "center", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "user-info" }, [
                          scope.row.userpic
                            ? _c("img", {
                                staticClass: "user-avatar",
                                attrs: {
                                  src: _vm.getCommentImageUrl(
                                    scope.row.userpic
                                  ),
                                },
                              })
                            : _c(
                                "div",
                                { staticClass: "user-avatar-default" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      (scope.row.mobilePhone || "U").slice(-1)
                                    )
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "user-detail" }, [
                            _c("div", { staticClass: "user-phone" }, [
                              _vm._v(_vm._s(scope.row.mobilePhone || "-")),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-rank" }, [
                              _vm._v(
                                _vm._s(_vm.getUserRankType(scope.row.userRank))
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "评分", align: "center", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "rating-container" }, [
                          _c(
                            "div",
                            { staticClass: "rating-item rating-service" },
                            [
                              _c("span", { staticClass: "rating-label" }, [
                                _vm._v("评分"),
                              ]),
                              _vm._v(" "),
                              _c("el-rate", {
                                attrs: {
                                  "show-score": "",
                                  "text-color": "#E6A23C",
                                  "score-template": "{value}",
                                  max: 5,
                                  size: "small",
                                },
                                model: {
                                  value: scope.row.score || 0,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "score||0", $$v)
                                  },
                                  expression: "scope.row.score||0",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dish",
                  label: "商品",
                  align: "center",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.goodsNameList,
                        function (item, idx) {
                          return _c("div", { key: item }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(idx + 1) +
                                "." +
                                _vm._s(item) +
                                "\n            "
                            ),
                          ])
                        }
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "评价", align: "center", "min-width": "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "comment-content" }, [
                          scope.row.goodContext.media &&
                          scope.row.goodContext.media.length > 0
                            ? _c(
                                "div",
                                { staticClass: "comment-images" },
                                _vm._l(
                                  scope.row.goodContext.media,
                                  function (image, index) {
                                    return _c("el-image", {
                                      key: index,
                                      staticClass: "comment-image",
                                      attrs: {
                                        src: image.img,
                                        "preview-src-list":
                                          scope.row.goodContext.media.map(
                                            function (item) {
                                              return item.img
                                            }
                                          ),
                                        fit: "cover",
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "comment-text" }, [
                            _vm._v(_vm._s(scope.row.goodContext.txt)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "下单/评论", align: "center", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "time-info" }, [
                          _c("div", { staticClass: "order-time" }, [
                            _vm._v(_vm._s(scope.row.pay)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "comment-time" }, [
                            _vm._v(_vm._s(scope.row.create)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: "操作",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReply(scope.row)
                                  },
                                },
                              },
                              [_vm._v("回复")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { margin: "4px 0" } }),
                            _vm._v(" "),
                            scope.row.score && scope.row.score < 3
                              ? [
                                  scope.row.processstatus === 2
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "small",
                                            disabled: "",
                                          },
                                        },
                                        [_vm._v("已和解")]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openReconciliationDialog(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("和解")]
                                      ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "和解",
            visible: _vm.reconciliationDialogVisible,
            width: "500px",
            "before-close": _vm.handleReconciliationClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.reconciliationDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.reconciliationForm, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "和解内容" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入和解内容",
                      rows: 4,
                      maxlength: "60",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.reconciliationForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.reconciliationForm, "content", $$v)
                      },
                      expression: "reconciliationForm.content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "和解图片" } }, [
                _c(
                  "div",
                  { staticClass: "image-upload-area" },
                  [
                    _vm.reconciliationForm.imageList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "image-list" },
                          _vm._l(
                            _vm.reconciliationForm.imageList,
                            function (img, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "image-item" },
                                [
                                  _c("img", { attrs: { src: img, alt: "" } }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeImage(index)
                                      },
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.reconciliationForm.imageList.length < 3
                      ? _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "#",
                              "show-file-list": false,
                              "http-request": _vm.handleImageUpload,
                              "before-upload": _vm.beforeImageUpload,
                              accept: "image/*",
                            },
                          },
                          [
                            _c("div", { staticClass: "upload-btn" }, [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("上传图片")]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-tip" }, [
                      _vm._v("最多上传3张图片"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { on: { click: _vm.handleReconciliationClose } },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.reconciliationLoading,
                  },
                  on: { click: _vm.submitReconciliation },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }